// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__16CXC","unreadBadge":"styles_unreadBadge__2HZ6g","modalContent":"styles_modalContent__3dO-T","modal":"styles_modal__3TlFj"};